import {ChildEntity} from "typeorm";
import {Competition} from ".";

@ChildEntity()
export class CupWithGroupCompetition extends Competition {
}
